import { createNamespacedHelpers, type Action, type MutationTree } from 'vuex';
import api from './api';

export const { mapState, mapActions } = createNamespacedHelpers('actionCentre');

const initialState = () => ({
  loading: false,
  connections: {
    filters: {
      direction: 'all',
      status: 'pending',
    },
  },
  remediations: {
    loaded: false,
    requests: [] as any[],
    filters: {
      direction: 'received',
      status: 'awaiting_response',
    },
    counts: {
      received: {
        total: 0,
        awaiting_response: 0,
        awaiting_review: 0,
        completed: 0,
      },
      sent: {
        total: 0,
        awaiting_response: 0,
        awaiting_review: 0,
        completed: 0,
      },
    },
  },
});

export type ActionCentreState = ReturnType<typeof initialState>;
export type ActionCentreFilters = { direction: string; status: string };

const mutations: MutationTree<ActionCentreState> = {
  SET_CONNECTION_REQUEST_FILTERS(state, filters: ActionCentreFilters) {
    state.connections.filters = filters;
  },
  GET_REMEDIATION_REQUESTS(state, data: any) {
    state.remediations.filters.status = data.status;
    state.remediations.filters.direction = data.direction;
    state.remediations.requests = data.results;
    state.remediations.counts.received = data.received;
    state.remediations.counts.sent = data.sent;
    state.loading = false;
    state.remediations.loaded = true;
  },
  START_LOADING(state) {
    state.loading = true;
  },
  CLEAR_STATE(state) {
    Object.assign(state, initialState());
  },
};

const setConnectionRequestsFilters: Action<ActionCentreState, any> = (
  { commit },
  filters: ActionCentreFilters,
) => {
  commit('SET_CONNECTION_REQUEST_FILTERS', filters);
};

const setRemediationRequestsFilters: Action<ActionCentreState, any> = async (
  { commit },
  filters: ActionCentreFilters,
) => {
  commit('START_LOADING');

  const res = await api.getRemediationRequests(filters.direction, filters.status);

  res.data.status = filters.status;
  res.data.direction = filters.direction;

  commit('GET_REMEDIATION_REQUESTS', res.data);
};

const clearActionCentre: Action<ActionCentreState, any> = ({ commit }) => {
  commit('CLEAR_STATE');
};

const actions = {
  setConnectionRequestsFilters,
  setRemediationRequestsFilters,
  clearActionCentre,
};

// TODO: replace with composables (0.5 days)
const actionCentreStore = {
  namespaced: true,
  state: initialState(),
  mutations,
  actions,
};

export default actionCentreStore;
